import { ConditionalDisplay } from '@rsos/base-components';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertEmergencyTypes';
import type { Alert } from '@rsos/reduxDataStore/src/features/alerts/alerts.types';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import styles from './ActiveAssailantBanner.module.scss';

// Stored sentence-case; the stylesheet renders it in caps so screen readers
// still announce a natural phrase rather than a string of capitals.
export const ACTIVE_ASSAILANT_BANNER_TEXT =
  'Active threat: dispatch with urgency';

// useSelectedAlert returns {} when no incident is selected, so accept a partial.
export const isActiveAssailantAlert = (
  alert: Partial<Alert> | null | undefined,
): boolean => alert?.emergency_type?.name === ACTIVE_ASSAILANT;

/**
 * Full-bleed red warning that takes over the iCSP nav bar for Active Assailant
 * incidents. It renders behind the nav content (see the module stylesheet) so it
 * adds no height to the fixed-height, no-scroll iCSP layout while still reading
 * as a full-width banner.
 */
const ActiveAssailantBanner = () => {
  const currentAlert = useSelectedAlert();

  return (
    <ConditionalDisplay
      dataName="icsp-active-assailant-banner"
      conditions={[
        {
          showIf: isActiveAssailantAlert(currentAlert),
          reason: 'Incident emergency type is not ACTIVE_ASSAILANT',
        },
      ]}
    >
      <div className={styles.banner}>
        <span role="alert" className={styles.message}>
          {ACTIVE_ASSAILANT_BANNER_TEXT}
        </span>
      </div>
    </ConditionalDisplay>
  );
};

export default ActiveAssailantBanner;
